import styled, { css } from 'styled-components';

export const ProductName = styled.h1`
  font-size: ${(props) =>
    props.isFertilityProduct
      ? 'clamp(14px, 3vw, 20px)'
      : 'clamp(18px, 3vw, 22px)'};
  color: hsl(0deg, 0%, 0%, 87%);
  font-weight: 500;
  line-height: ${(props) => (props.isFertilityProduct ? '1.5' : '1.25')};
  padding: 4px 0;
`;

export const ProductPrice = styled.div`
  display: flex;
  align-items: ${(props) => (!props.perUnit ? 'flex-end' : 'baseline')};
  padding-bottom: 4px;
  margin-top: 4px;
  flex-direction: ${(props) => (props.perUnit ? 'column' : '')};
  .price {
    display: flex;
    align-items: flex-end;
    padding-bottom: 8px;
  }
  .mainPriceContainer {
    display: flex;
    align-items: baseline;
  }
  .pricePerUnit {
    font-size: 14px;
    text-align: left;
    color: rgba(0, 0, 0, 0.4);
  }
`;

export const TotalAmount = styled.span`
  font-weight: 500;
  color: hsl(0deg 0% 0% / 87%);
  font-size: ${(props) =>
    props.card ? '13px' : props.isUAE ? '16px' : '18px'};
  font-weight: ${(props) => (props.card ? '500' : '600')};
  padding-right: ${(props) =>
    props.card ? '8px' : props.perUnit ? '4px' : '12px'};
  display: flex;
  sup {
    font-size: 12px;
    margin-top: 2.5px;
    margin-right: 2px;
  }
`;

export const StrikePrice = styled.p`
  color: hsl(0deg, 0%, 0%, 40%);
  font-size: ${(props) => (props.card ? '12px' : '14px')};

  font-weight: 400;
  padding-right: ${(props) => (props.card ? '8px' : '12px')};
  span {
    text-decoration: line-through;
  }
`;
export const Discount = styled.p`
  font-size: ${(props) => (props.card ? '12px' : '14px')};
  color: hsl(174deg 33% 54%);
  text-decoration: none;
  font-weight: 700;
`;

export const Image = styled.img`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin: ${(props) => props.margin};
  border-radius: ${(props) => props.radius};
  zoom: ${(props) => props.zoom};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
`;

export const FlexCenter = styled.div`
  display: ${(props) => (props.clinic ? 'none' : 'flex')};
  align-items: ${(props) => (props.review ? 'flex-start' : 'center')};
  padding: ${(props) => props.padding};
  justify-content: ${(props) => props.justify};
  overflow-x: ${(props) => props.overflowX};
  cursor: pointer;

  @media (max-width: 720px) {
    display: ${(props) => props.newReview};
  }

  @media (max-width: 720px) {
    & ::-webkit-scrollbar {
      display: none;
    }
  }

  &.borderRight {
    border-right: 2px solid #e1e1e1;
  }

  & .reviewbodyfull {
    width: 100%;

    h4 {
      font-weight: 500;
      padding-bottom: 12px;
      font-size: 15px;
      text-transform: capitalize;
    }

    div {
      font-size: 14px;
      flex-direction: column;
    }
  }
  & .reviewbody {
    width: 90%;

    div {
      font-size: 14px;
    }
  }
  & .reviewImage {
    height: 92px;
    width: 92px;
    float: right;
    object-fit: cover;
    border-radius: 4px;
  }
  & .react_ProductReviewItem_show_more {
    color: #63b0a8;
  }
`;

export const FreeDelivery = styled.p`
  padding-left: 6px;
  color: hsl(0deg 0% 0% / 70%);
  font-size: clamp(12px, 2vw, 14px);
`;
export const Sprite = styled.span`
  margin: 0 0 0 4px;
`;

export const DescWrapper = styled.div`
  margin: 10px 0;
  p {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
  }
`;

export const FertilityDescription = styled.div`
  margin: 10px 0 16px;
  p {
    font-size: clamp(12px, 3vw, 15px);
    padding: 6px 12px;
    background: rgb(170 234 244 / 28%);
    border-radius: 6px;
    color: rgba(0, 0, 0, 0.7);
    font-weight: 400;
    @media (min-width: 768px) {
      width: 80%;
    }
  }
  span {
    color: #028b9a;
    font-weight: 500;
  }
  &.lowOpac {
    opacity: 0.6;
  }
  ${(props) =>
    props.clickable
      ? css`
          @media (min-width: 720px) {
            cursor: pointer;
          }
        `
      : null}
`;

export const FertilityDescriptionNew = styled.div`
  margin: 0;
  font-size: ${(props) => (props.desktop ? '16px' : '13px')};
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
  line-height: 1.38;
  @media (min-width: 768px) {
    width: 80%;
  }

  ${(props) =>
    props.clickable
      ? css`
          @media (min-width: 720px) {
            cursor: pointer;
          }
        `
      : null}
`;

export const DesktopHidden = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;
export const MobileHidden = styled.div`
  @media (max-width: 768px) {
    display: ${(props) => (props.showAPlusPlusExp ? 'none' : 'block')};
  }
`;

export const SpecialPriceStyle = styled.div`
  position: relative;
  color: #ad7c4c;
  background: linear-gradient(to right, #fec694, #ffffff);
  padding: ${(props) => (props.mobile ? '5px 8px' : '7px 16px')};
  display: flex;
  justify-content: center;
  width: fit-content;
  font-weight: 500;
  font-size: ${(props) => (props.mobile ? '10px' : '14px')};
  margin: 0px 0 6px -16px;
  @media (min-width: 720px) {
    margin-left: 0px;
  }
  span {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    background: linear-gradient(
      105deg,
      transparent 10%,
      rgb(255 255 255) 25%,
      transparent 30%,
      transparent 50%
    );

    width: 120%;
    height: 100%;
    animation: move_continue 2s;
    animation-iteration-count: infinite;
    animation-delay: 1s;
  }

  @keyframes move_continue {
    0% {
      left: 0;
      opacity: 0.4;
    }

    10% {
      opacity: 0.5;
    }

    60% {
      opacity: 0.8;
    }
    90% {
      opacity: 1;
    }

    100% {
      left: 82%;
    }
  }
`;

export const ProductPriceNew = styled.div`
  display: flex;
  padding-bottom: 4px;
  margin-top: 4px;
  flex-direction: column;
  .price {
    display: flex;
    align-items: flex-end;
    padding-bottom: 8px;
    align-items: center;
    column-gap: 10px;
  }
  .mainPriceContainer {
    display: flex;
    align-items: baseline;
  }
  .pricePerUnit {
    font-size: 12px;
    text-align: left;
    color: rgba(0, 0, 0, 0.6);
  }
`;

export const TotalAmountNew = styled.span`
  font-weight: 500;
  color: hsl(0deg 0% 0% / 87%);
  font-size: ${(props) =>
    props.card ? '13px' : props.isUAE ? '16px' : '22px'};
  font-weight: ${(props) => (props.card ? '500' : '600')};
  padding-right: 4px;
  display: flex;
  sup {
    font-size: 12px;
    margin-top: 2.5px;
    margin-right: 2px;
  }
`;

export const StrikePriceNew = styled.p`
  color: hsl(0deg, 0%, 0%, 60%);
  font-size: ${(props) => (props.card ? '12px' : '14px')};

  font-weight: 400;
  padding-right: ${(props) => (props.card ? '8px' : '12px')};
  span {
    text-decoration: line-through;
  }
`;

export const NewLandingPagePrice = styled.div`
  .priceFlex {
    display: flex;
    align-items: center;
    gap: 10px;
    background-image: linear-gradient(to right, #d3e8e678, #fff);
    font-size: 16px;
    font-weight: 600;
    padding: 12px 16px;
  }
  .discount {
    color: #63b0a9;
  }
  .price {
    color: rgba(0, 0, 0, 0.87);
    font-size: 18px;
  }
  .pricePerUnit {
    color: #6e6e6e;
    font-weight: normal;
    font-size: 14px;
  }
  .strikePrice {
    font-size: 16px;
    margin-top: 10px;
    padding-left: 16px;
    font-weight: normal;
    color: #6e6e6e;
    span {
      text-decoration: line-through;
    }
    .incTax {
      text-decoration: none;
      font-size: 12px;
      padding-left: 2px;
    }
  }
  @media (max-width: 768px) {
    margin-left: -16px;
  }
`;

export const WrapperContainer = styled.div`
  padding: 16px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr); // Equal columns for 3 items
 
  width: 100%;
  justify-content: space-evenly;
  align-items: ${(props) => (props.isDetergentProduct ? '' : 'center')};
  @media (min-width: 720px) {
    gap: 20px;
    padding: 21px 0;
  }
  .featuresInner {
     text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-self: center; // Center within grid cell
    
  
    img {
      max-width: 42px;
      min-width: 42px;
      min-height: 42px;
    }
    @media (min-width: 720px) {
      img {
        width: 50px;
        height: 50px;
        max-width: 96px;
      }
    }

        p {
      font-size: clamp(11px, 2vw, 14px);
      max-width: 110px;
      color: rgba(0, 0, 0, 0.87);
      text-align: center;
      @media (min-width: 720px) {
        max-width: 122px;
      }
    }
  }
`;
